export const LOGO_URL = "/brand-donut.png?v=3";

export const FULL_LOGO_URL = "/full-logo.png?v=2";

export const TRUCK_IMG =
  "https://customer-assets.emergentagent.com/job_bobo-donuts-hub/artifacts/7fb3kzdz_IMG_9154.png";

export const ZACH_WINDOW_IMG =
  "https://customer-assets.emergentagent.com/job_bobo-donuts-hub/artifacts/noo7q9lf_IMG_9198.jpeg";

export const WOODGRAIN_IMG =
  "https://static.prod-images.emergentagent.com/jobs/e4d4a438-f853-41d1-bcb5-39784edf4d79/images/bf0cce2d799059762fb551e0bffdb4dcf2d7bec9a90404cd5e993026add6b1fd.png";

export const FACEBOOK_URL =
  "https://www.facebook.com/profile.php?id=61580156697490";

export const INSTAGRAM_URL =
  "https://www.instagram.com/bobosdonutsmattawan";

export const NAV_LINKS = [
  { id: "donuts", label: "Donuts" },
  { id: "locations", label: "Truck" },
  { id: "truck", label: "Mission" },
  { id: "quote", label: "Catering" },
];

// Temporarily unsurfaced — restore these entries to bring the menu items back:
//   { id: "story", label: "Our Story" },
//   { id: "merch", label: "Merch" },
//   { id: "rewards", label: "Rewards" },

export const MERCH = [
  {
    name: "Donut Dad Hat",
    desc: "Cream embroidered cap with a little pink donut patch. One size, all smiles.",
    price: "$25",
    donation: "For each hat sold, $5 goes straight to Zach's Foundation.",
    img: "https://customer-assets.emergentagent.com/job_bobo-donuts-hub/artifacts/99h7b5hh_ChatGPT%20Image%20Jun%2019%2C%202026%2C%2003_45_33%20PM.png",
  },
  {
    name: "Cozy Crewneck",
    desc: "Super-soft hoodie for sweet-tooth season. Sizes XS–3XL.",
    price: "$52",
    donation: "For each sweatshirt sold, $13 goes straight to Zach's Foundation.",
    img: "https://customer-assets.emergentagent.com/job_bobo-donuts-hub/artifacts/c812s18f_IMG_0355.png",
  },
  {
    name: "DAD BOD Tee",
    desc: "Classic cream cotton tee with our signature pink donut. Sizes XS–3XL.",
    price: "$30",
    donation: "For each t-shirt sold, $8 goes straight to Zach's Foundation.",
    img: "https://customer-assets.emergentagent.com/job_bobo-donuts-hub/artifacts/sh0p66hs_IMG_0354.png",
  },
  {
    name: "Pink Donut Mug",
    desc: "A glossy pink ceramic mug — the perfect sidekick for donuts & coffee.",
    price: "$25",
    donation: "For each mug sold, $5 goes straight to Zach's Foundation.",
    img: "https://customer-assets.emergentagent.com/job_bobo-donuts-hub/artifacts/1zroa3p6_pink%20donut%20mug.png",
  },
  {
    name: "CORKCICLE® Tumbler",
    desc: "Insulated stainless travel cup to take Bobo's energy on the road.",
    price: "$46",
    donation: "For each tumbler sold, $13 goes straight to Zach's Foundation.",
    img: "https://customer-assets.emergentagent.com/job_bobo-donuts-hub/artifacts/58yntftt_E46BD78B-6660-4BF7-BED7-A7690279FAD6.png",
  },
];

// The July 4th "The 250" drop auto-retires at the end of July 4 (Eastern time).
// After this instant the seasonal donut, hero ribbon, timer, and fireworks all hide.
export const JULY4_DROP_END = "2026-07-05T00:00:00-04:00";
export function isJuly4DropActive(now = new Date()) {
  return now.getTime() < new Date(JULY4_DROP_END).getTime();
}

// Shared red→blue gradient for the July 4th drop (hero ribbon + donut tag).
export const JULY4_GRADIENT =
  "linear-gradient(90deg,#c1272d 0%,#8e2c6b 50%,#2a3d8f 100%)";

export const DONUTS = [
  {
    name: "The 250",
    desc: "A pillowy glazed donut crowned with a thick layer of pure white vanilla frosting, then dusted all over with sparkling red and blue sugar crystals — our star-spangled drop for America's 250th birthday.",
    tag: "Special 4th of July Drop!",
    color: "#f0dcc0",
    img: "/donuts/the250.png?v=2",
    fireworks: true,
    seasonal: "july4",
  },
  {
    name: "The Logo",
    desc: "Our signature ring dipped in strawberry-pink frosting and finished with chocolate jimmies.",
    tag: "Signature",
    color: "#ff648b",
    hidden: true,
    img: "/donuts/logo.png?v=5",
  },
  {
    name: "Just Glazed",
    desc: "The timeless classic — pillowy soft dough under a glossy, melt-in-your-mouth sugar glaze.",
    tag: "Classic",
    color: "#e9c9a3",
    img: "/donuts/glazed.png?v=5",
    vegan: true,
  },
  {
    name: "Cinnamon Sugarlicious",
    desc: "Warm cake donut rolled generously in sweet cinnamon sugar. Cozy in every bite.",
    tag: "Zach's Favorite!",
    color: "#d8a878",
    img: "/donuts/cinnamon.png?v=13",
  },
  {
    name: "The Kitchen Sink",
    desc: "A pillowy glazed donut slathered with rich chocolate frosting and piled edge-to-edge with colorful rainbow jimmies.",
    tag: "Kids Love It",
    color: "#b98a6a",
    img: "/donuts/choco.png?v=11",
  },
  {
    name: "Seaside Caramel",
    desc: "A pillowy glazed donut topped with a thick, hand-swirled layer of salted caramel icing — buttery, sweet, and finished with a hint of sea salt.",
    tag: "New",
    color: "#dcbf94",
    img: "/donuts/caramel.png?v=11",
  },
  {
    name: "Lavender Dream",
    desc: "A pillowy glazed donut with a delicate lavender glaze — made with lavender sourced right here at Shades of Lavender farm in Mattawan, MI. Soft, sweet and dreamy.",
    tag: "Limited Drop",
    color: "#c9b6e0",
    heroColor: "#e9c9a3",
    availability: "Only at Shades of Lavender Farm",
    availableAt: "Shades of Lavender",
    img: "/donuts/lavender.png?v=15",
    vegan: true,
  },
  {
    name: "LemonDrop Pop",
    desc: "A poppy-seed sourdough donut finished with a bright, glossy lemon poppy-seed glaze. Zesty and addictive.",
    tag: "New",
    color: "#ecd98a",
    hidden: true,
    img: "/donuts/lemondrop.png?v=1",
    vegan: true,
  },
  {
    name: "Drunk Lumberjack",
    desc: "A cinnamon-swirl donut drizzled with a boozy Woodinville® bourbon-maple icing. Sweet, warm and a little wild.",
    tag: "New",
    color: "#c98f4e",
    hidden: true,
    img: "/donuts/drunklumberjack.png?v=1",
  },
  {
    name: "The Captain Leverett",
    desc: "An elevated vegan carrot cake donut with The Kraken® soaked raisins and Cointreau® cream cheese frosting.",
    tag: "New",
    color: "#e0a96d",
    hidden: true,
    img: "/donuts/captainleverett.png?v=4",
    vegan: true,
  },
  {
    name: "The Logo, Protein Power Pack",
    line1: "The Logo",
    line2: "Protein Power Pack",
    desc: "A vegan take on The Logo — vibrant strawberry frosting and protein-packed berry SprinkleBites™. All for under 160 calories with over 10g of protein.",
    tag: "Protein Power",
    color: "#ff648b",
    hidden: true,
    img: "/donuts/proteinlogo.png?v=1",
    vegan: true,
  },
  {
    name: "Just Glazed Donut Holes",
    desc: "Bite-size glazed donut holes — that same glossy classic glaze in a poppable, share-friendly form.",
    tag: "Donut Holes",
    color: "#e9c9a3",
    img: "/donuts/glazedholes.png?v=7",
    vegan: true,
  },
  {
    name: "Lavender Dream Donut Holes",
    desc: "Our dreamy lavender-glazed donuts, shrunk down into little two-bite clouds — made with lavender sourced from Shades of Lavender in Mattawan, MI.",
    tag: "Limited Drop",
    color: "#c9b6e0",
    heroColor: "#e9c9a3",
    availability: "Only at Shades of Lavender Farm",
    availableAt: "Shades of Lavender",
    img: "/donuts/lavenderholes.png?v=9",
    vegan: true,
  },
  {
    name: "Cinnamon Sugarlicious Donut Holes",
    desc: "Warm cake donut holes rolled generously in sweet cinnamon sugar — cozy, poppable, two-bite happiness.",
    tag: "Donut Holes",
    color: "#d8a878",
    img: "/donuts/cinnamonholes.png?v=1",
  },
  {
    name: "ChocoRama Donut Holes",
    desc: "Plain glazed chocolate cake donut holes made with vegan cocoa — no icing, no sprinkles, just rich poppable chocolate.",
    tag: "Donut Holes",
    color: "#b98a6a",
    hidden: true,
    img: "/donuts/chocoholes.png?v=3",
    vegan: true,
  },
  {
    name: "LemonDrop Pop Donut Holes",
    desc: "Bite-size poppy-seed sourdough holes glazed in zesty lemon — pop one (or five).",
    tag: "Donut Holes",
    color: "#ecd98a",
    hidden: true,
    img: "/donuts/lemonholes.png?v=2",
    vegan: true,
  },
  {
    name: "Drunk Lumberjack Donut Holes",
    desc: "Cinnamon-swirl donut holes glazed in boozy bourbon-maple. Dangerously poppable.",
    tag: "Donut Holes",
    color: "#c98f4e",
    hidden: true,
    img: "/donuts/drunkholes.png?v=1",
    vegan: true,
  },
  {
    name: "Honey-B Donut Holes",
    desc: "Honey donut holes drizzled with bright citrus-yellow and dark chocolate icing. The only hole that isn't vegan — and worth it.",
    tag: "Donut Holes",
    color: "#e3a92e",
    hidden: true,
    img: "/donuts/honeyholes.png?v=1",
  },
];

export const LOCATIONS = [
  {
    day: "Thursday",
    date: "June 25th",
    iso: "2026-06-25",
    place: "Private Event",
    time: "",
    address: "",
  },
  {
    day: "Friday",
    date: "June 26th",
    iso: "2026-06-26",
    place: "McGillen's Crossing, Mattawan (Taco Bob's)",
    time: "8:00 AM – 12:00 PM",
    start: "08:00",
    end: "12:00",
    address: "23980 City Center Cir, Mattawan, MI",
  },
  {
    day: "Saturday",
    date: "June 27th",
    iso: "2026-06-27",
    place: "Shades of Lavender Farm",
    time: "8:00 AM – 12:00 PM",
    start: "08:00",
    end: "12:00",
    address: "47222 24th St, Mattawan, MI",
  },
];

// Availability helper — given a location-name fragment, returns whether the
// truck is parked there today and how many days until the next visit (weekly cadence).
export function getAvailability(matchStr, locations = LOCATIONS) {
  const loc = locations.find(
    (l) => l.place && l.place.toLowerCase().includes(matchStr.toLowerCase())
  );
  if (!loc) return null;
  const dayMap = { Sunday: 0, Monday: 1, Tuesday: 2, Wednesday: 3, Thursday: 4, Friday: 5, Saturday: 6 };
  const target = dayMap[loc.day];
  if (target === undefined) return null;
  const daysUntil = (target - new Date().getDay() + 7) % 7;
  return { availableToday: daysUntil === 0, daysUntil, day: loc.day, place: loc.place };
}

// Whether the truck is open to the public today (weekly cadence). A public stop has
// serving hours; "Private Event" days (no hours) count as closed.
export function getTruckOpen() {
  const dayMap = { Sunday: 0, Monday: 1, Tuesday: 2, Wednesday: 3, Thursday: 4, Friday: 5, Saturday: 6 };
  const openDays = LOCATIONS.filter((l) => l.time)
    .map((l) => dayMap[l.day])
    .filter((d) => d !== undefined);
  if (openDays.length === 0) return null;
  const today = new Date().getDay();
  if (openDays.includes(today)) return { availableToday: true, daysUntil: 0 };
  let best = 7;
  for (const d of openDays) {
    const diff = (d - today + 7) % 7;
    if (diff > 0 && diff < best) best = diff;
  }
  return { availableToday: false, daysUntil: best };
}

// Time-aware truck status in US Eastern time, based on weekly serving hours.
// Returns { openNow, phrase, daysUntil } or null if no public serving hours exist.
//   open right now            -> phrase "NOW",      daysUntil 0
//   closed, opens later today -> phrase "today",    daysUntil 0
//   opens tomorrow            -> phrase "tomorrow", daysUntil 1
//   opens a later weekday     -> phrase weekday name, daysUntil N
export function getTruckStatus(locations = LOCATIONS) {
  const dayMap = { Sunday: 0, Monday: 1, Tuesday: 2, Wednesday: 3, Thursday: 4, Friday: 5, Saturday: 6 };
  const toMin = (s) => {
    const [h, m] = s.split(":").map(Number);
    return h * 60 + m;
  };
  const sched = {};
  for (const l of locations) {
    if (l.start && l.end && dayMap[l.day] !== undefined) {
      sched[dayMap[l.day]] = { start: toMin(l.start), end: toMin(l.end) };
    }
  }
  if (Object.keys(sched).length === 0) return null;

  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(new Date());
  const get = (t) => parts.find((p) => p.type === t)?.value;
  const shortMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  const names = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const today = shortMap[get("weekday")];
  let hh = parseInt(get("hour"), 10);
  if (hh === 24) hh = 0;
  const nowMin = hh * 60 + parseInt(get("minute"), 10);

  if (sched[today]) {
    if (nowMin >= sched[today].start && nowMin < sched[today].end)
      return { openNow: true, phrase: "NOW", daysUntil: 0 };
    if (nowMin < sched[today].start)
      return { openNow: false, phrase: "today", daysUntil: 0 };
  }
  for (let i = 1; i <= 7; i++) {
    const d = (today + i) % 7;
    if (sched[d]) {
      if (i === 1) return { openNow: false, phrase: "tomorrow", daysUntil: 1 };
      return { openNow: false, phrase: names[d], daysUntil: i };
    }
  }
  return null;
}
